
<app-left-tab></app-left-tab>

<app-right-tab></app-right-tab>

<app-speed-dial-fab [options]="FabOptions" class="fab-button"></app-speed-dial-fab>
